<template>
  <v-row>
    <!-- Start Single Address  -->
    <v-col
      lg="6"
      md="6"
      sm="6"
      cols="12"
      v-for="(address, i) in addressContent"
      :key="i"
    >
      <div class="rn-address" :class="address.isAddress">
        <div class="icon" v-html="iconSvg(address.icon)"></div>
        <div class="inner">
          <h4 class="heading-title">{{ address.title }}</h4>
          <p>
            <a :href="address.to1">{{ address.info1 }}</a>
          </p>
          <!-- <p>
            <a :href="address.to2">{{ address.info2 }}</a>
          </p> -->
        </div>
      </div>
    </v-col>
    <!-- End Single Address  -->
  </v-row>
</template>

<script>
  import feather from "feather-icons";
  export default {
    data() {
      return {
        addressContent: [
          {
            icon: "headphones",
            title: "Número de telefone de contato",
            info1: "+55 11 97447-4061",
            info2: "+222 222 222 333",
            to1: "tel:+55 11 97447-4061",
            to2: "tel:+222 222 222 333",
          },
          {
            icon: "mail",
            title: "Nosso e-mail",
            info1: "contato@foreverjobsbrasil.com.br",
            info2: "example@gmail.com",
            to1: "mailto:contato@foreverjobsbrasil.com.br",
            to2: "mailto:example@gmail.com",
          },
        ],
      };
    },
    methods: {
      iconSvg(icon) {
        return feather.icons[icon].toSvg();
      },
    },
  };
</script>

<style lang="scss">
  .addres-last {
    p {
      pointer-events: none;
    }
  }
</style>
